/* tslint:disable */
/* eslint-disable */
export enum ControlQuestionAnswer {
  Yes = 'YES',
  No = 'NO'
}
